export const eventHandlers = {
  PRODUCT_LIST_PAGE_VIEW: 'PRODUCT_LIST_PAGE_HIT',
  SELECT_CONTENT_PRODUCT_LIST: 'SELECT_CONTENT_PRODUCT_LIST_CLICK',
  SELECT_ITEM_PRODUCT_LIST: 'SELECT_ITEM_PRODUCT_LIST_CLICK',
};
